var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7103 0.0820312H2.2512C1.54274 0.0820312 0.970367 0.654403 0.970367 1.36286V30.822C0.970367 31.5304 1.54274 32.1028 2.2512 32.1028H31.7103C32.4188 32.1028 32.9911 31.5304 32.9911 30.822V1.36286C32.9911 0.654403 32.4188 0.0820312 31.7103 0.0820312ZM28.0119 9.4281H25.4543C23.449 9.4281 23.0607 10.3807 23.0607 11.7816V14.8676H27.8478L27.2234 19.6988H23.0607V32.1028H18.0695V19.7028H13.8948V14.8676H18.0695V11.3053C18.0695 7.17063 20.5951 4.91717 24.2855 4.91717C26.0546 4.91717 27.5716 5.04925 28.0159 5.10929V9.4281H28.0119Z",
    fill: "#2091F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb2);
export default __webpack_public_path__ + "static/media/fb2.d71fa65c0bf0d1465a7d8efd11f4a121.svg";
export { ForwardRef as ReactComponent };